import {
  type ListUserProfilesFullPageRequest,
  type UserProfileRoleOut,
  listUserProfilesFullPagePassportIdmIdmListUserProfilesFullPagePost,
} from '@/shared/api/intranet'

export const listUserProfilesFullPage = async ({
  page = {
    number: 1,
    size: 1,
  },
  filter = {
    query: '',
    ids: [],
    role: undefined,
  },
  signal,
}: ListUserProfilesFullPageRequest & { signal?: AbortSignal }): Promise<{
  totalItems: number
  totalPages: number
  userProfiles: UserProfileRoleOut[]
}> => {
  const { data } = await listUserProfilesFullPagePassportIdmIdmListUserProfilesFullPagePost({
    body: {
      page,
      filter,
    },
    throwOnError: true,
    signal,
  })

  return {
    userProfiles: data.userProfiles,
    totalPages: data.pagination.totalPages,
    totalItems: data.pagination.totalItems,
  }
}
